import Display from "./Display";
import Form from "./Form";
import SuccessState from "./SuccessState";
import { useState } from "react";

const Main = () => {
    const [formData, setFormData] = useState({
        cardNumber: '0000 0000 0000 0000',
        cardName: "JANE APPLESEED",
        mm: "00",
        yy: "00",
        cvc: '000'
    });

    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleFormSubmit = () => {
        setIsSubmitted(!isSubmitted);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };


    return ( 
        <main>
            <Display {...formData} />
            {!isSubmitted && <Form isSubmitted={isSubmitted} handleInputChange={handleInputChange} handleFormSubmit={handleFormSubmit} />}
            {isSubmitted && <SuccessState isSubmitted={isSubmitted} handleFormSubmit={handleFormSubmit} />}
        </main>
     );
}
 
export default Main;